import { useContext, useEffect, useState } from "react";

import { BrowserRouter, Switch, Route as RouteDom } from "react-router-dom";

import queryString from "query-string";

import Marketplaces from "./pages/integracao/marketplaces/Marketplaces";
import CNDPainel from "./pages/CND/CNDPainel";
import ListagemCliente from "./pages/cliente/ListagemCliente";
import CadastroCliente from "./pages/cliente/CadastroCliente";
import EdicaoCliente from "./pages/cliente/EdicaoCliente";
import CNDCadastro from "./pages/CND/CNDCadastro";
import CNDEdicao from "./pages/CND/CNDEdicao";
import CNDManual from "./pages/CND/CNDManual";
import Health from "./pages/Health";
import { QueryParamsContext } from "./context/QueryParamsContext";

const Route = ({ path, component: Component }) => {
  const { setQueryParams, setTempQueryParams } = useContext(QueryParamsContext);

  const [lastParams, setLastParams] = useState("");

  useEffect(() => {
    if (!window.location || !window.location.search) return;

    if (window.location.search !== lastParams) {
      setLastParams(window.location.search);

      const params = queryString.parse(window.location.search);

      let tempParams = {};

      Object.keys(params).forEach((key) => {
        if ((key || "").startsWith("tempParam_")) {
          tempParams[key.replace("tempParam_", "")] = params[key];
          delete params[key];
        } else {
          sessionStorage.setItem(key, params[key]);
        }
      });

      setTempQueryParams(tempParams);

      setQueryParams((current) => ({ current, ...sessionStorage, ...params }));
    }
  }, [lastParams, setQueryParams, setTempQueryParams]);

  return <RouteDom path={path} component={Component} />;
};

const Routes = () => {
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path="/integracao/marketplaces" component={Marketplaces} />
          <Route path="/health" component={Health} />

          <Route path="/cnd/painel" component={CNDPainel} />
          <Route path="/cnd/cadastro" component={CNDCadastro} />
          <Route path="/cnd/edicao" component={CNDEdicao} />
          <Route path="/cnd/manual" component={CNDManual} />

          <Route path="/cliente/listagem" component={ListagemCliente} />
          <Route path="/cliente/cadastro" component={CadastroCliente} />
          <Route path="/cliente/edicao" component={EdicaoCliente} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default Routes;
